import {
  type ApiInspectionsV1GenerateInspectionLinkUpdateMutationBody,
  InspectionLink as InspectionLinkResponse,
  useApiInspectionsV1GenerateInspectionLinkUpdate,
} from 'api';
import { useTranslation } from 'i18n';
import { Button, Tooltip } from 'ui';
import { MobileScreenShare } from 'ui/icons';

export const InspectionLink = ({ inspectionId, disabled }: { inspectionId?: number; disabled: boolean }) => {
  const { t } = useTranslation('orders');
  const { mutate } = useApiInspectionsV1GenerateInspectionLinkUpdate();
  const tooltipText = disabled
    ? t('inspectionLink.tooltips.onlyInspectionsWithGrade')
    : t('inspectionLink.tooltips.copyToClipboard');

  const handleCopyInspectionLink = () => {
    if (!inspectionId) {
      return;
    }

    mutate(
      {
        data: {} as ApiInspectionsV1GenerateInspectionLinkUpdateMutationBody,
        id: inspectionId,
      },
      {
        onSuccess: (data: InspectionLinkResponse) => {
          navigator.clipboard.writeText(data.inspection_url);
        },
      }
    );
  };

  return (
    <Tooltip title={tooltipText}>
      <div>
        <Button
          disabled={disabled}
          endIcon={<MobileScreenShare />}
          aria-label={t('inspectionLink.actions.copyInspectionLinkAriaLabel')}
          variant="secondary"
          onClick={handleCopyInspectionLink}
        >
          {t('inspectionLink.actions.inspectionLink')}
        </Button>
      </div>
    </Tooltip>
  );
};
